module.exports = __webpack_public_path__ + "img/comYou.b2bb09a9.png";